import {openResourceSection} from '../../core/resourceEvents';
import {BACKUP_SECTION_EVENT} from './events';

const BACKUP_SECTIONS = new Set(['maintenance.backup']);

/**
 * Open the Backup tab without selecting Site or System Backup.
 * @return {Promise<void>} completion acknowledgement
 */
export function openBackupSection() {
	return openResourceSection(
		BACKUP_SECTION_EVENT,
		'maintenance.backup',
		BACKUP_SECTIONS,
	);
}
